import custom_axios from "../axios";

export const CREATE_ORDER = async (order_number) => {
  try {
    const response = await custom_axios.post(`/order/create`, {
      orders: [ order_number ].flat() 
    });
    return response.data;
  } catch (error) {
    console.error("Failed to create order:", error);
    throw error;
  }
};

export const DELETE_ORDER = async (orderIds) => {
  try {
    const queryString = Array.isArray(orderIds) 
      ? orderIds.map(id => `order_ids=${id}`).join('&')
      : `order_ids=${orderIds}`;      
    const response = await custom_axios.delete(`/order/custom-order/multiple?${queryString}`);
    return response.data;
  } catch (error) {
    console.error("Failed to delete orders:", error);
    throw error;
  }
};
